import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { CORE_ROUTE } from "@obg/ngx.core";
import { PlatformService } from "@obg/ngx.global.evo";
import { RouteAction, RouteSelector } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, tap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { GeoFencingAction } from "./geofencing.action";
import { GeofencingSelector } from "./geofencing.selector";
import { GeofencingService } from "./geofencing.service";

@Injectable({ providedIn: "root" })
export class BrazilGeofencingGuard implements CanActivate {
	constructor(
		private platformService: PlatformService,
		private store: Store<CommonState>,
		private geofencingService: GeofencingService
	) {}

	canActivate(): Observable<boolean> {
		if (this.platformService.isServer || !this.geofencingService.isBrazilGeofencingEnabled()) {
			return of(true);
		}

		return this.store.select(GeofencingSelector.isBusy).pipe(
			filter((isBusy) => !isBusy),
			switchMap(() => this.store.select(GeofencingSelector.isValid)),
			tap((isValid) => {
				if (isValid === undefined) {
					this.store.dispatch(GeoFencingAction.validateBrazilLocation());
				}
			}),
			ignoreNil(),
			withLatestFrom(this.store.select(RouteSelector.getCurrent)),
			map(([isValid, currentRoute]) => {
				if (!isValid && !currentRoute) {
					this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home, {}, { onSameUrlNavigation: "reload" }));
				}

				return isValid;
			}),
			tap(() => {
				this.store.dispatch(GeoFencingAction.resetError());
			})
		);
	}
}
